'use strict';

var _ = require('underscore'),
    SectionTypes = require('../constants/SectionTypes');

var AllowedTypes = [
  SectionTypes.COVER,
  SectionTypes.GALLERY,
  SectionTypes.POSTER
];

function getAllStampImages(stamp) {
  return _.chain(stamp.content.sections)
    .filter(section => AllowedTypes.indexOf(section.type) > -1)
    .map(section => section.background || section.images)
    .flatten()
    .compact()
    .value();
}

module.exports = getAllStampImages;


/** WEBPACK FOOTER **
 ** ./utils/getAllStampImages.js
 **/